import React from 'react';

/**
 * region for libraries*/
import PropTypes from 'prop-types';

/**
 * region for helpers*/
import typing from '../../helpers/typing';
import validation from '../../helpers/validation';
import ajax from '../../helpers/ajax';

/**
 * region for components*/
import { BaseComponent } from './BaseComponent';
import { InputText } from './InputText';

/**
 * region for constans*/
import Constants from '../../constants/Constants';


export class InlineTextEditor extends BaseComponent {
    static displayName = InlineTextEditor.name;

    constructor(props) {
        super(props);

        this.state = {
            mode: Constants.MODE_VIEW,
            validators: validation.getValidators(props.tableName, props.fieldName, props.validations),
            alias: validation.getFieldAlias(props.tableName, props.fieldName),
            manageTrashButton: props.manageTrashButton
        };
        this.hasChanges = false;
    }

    handleStartEdition(event) {
        event.preventDefault();
        this.state.pendingChanges = {};
        if (this.state.mode !== Constants.MODE_EDITION) {
            this.setState({ mode: Constants.MODE_EDITION });
        }
    }

    handleCompleteEdition(event) {
        event.preventDefault();
        const self = this;
        if (this.hasChanges && this.state.pendingChanges[self.props.fieldName] !== self.props.row[self.props.fieldName]) {

            const mappedValidation = self.state.validators.map(
                function (validator) {
                    return validator(self.state.pendingChanges[self.props.fieldName], self.props.tableName, self.props.fieldName, self.props.row);
                }
            );

            Promise.all(mappedValidation).then(
                validationResults => {
                    if (validation.getResultSimplifiedForField(validationResults).valid) {
                        let value = self.state.pendingChanges[self.props.fieldName];
                        if (value && typing.isString(value)) {
                            value = value.trim();
                        }
                        self.saveData(value,
                            self,
                            function () {
                                self.props.row[self.props.fieldName] = value;
                                self.acceptChanges(self);
                                if (self.props.handleCompleteSave) {
                                    self.props.handleCompleteSave();
                                }
                            });
                    }
                    else {
                        if (event.stopImmediatePropagation) {
                            event.stopImmediatePropagation();
                        }
                    }
                }
            );

        }
        else {
            self.acceptChanges(self);
        }
    }
    saveData(value, self, callbackSuccess) {

        const requestData = {
            idContent: self.props.idContent,
            idContentType: self.props.idContentType,
            data: [
                {
                    key: self.props.fieldName,
                    value: value
                }
            ]
        };

        if (this.props.idExtended) {
            requestData.idExtended = this.props.idExtended;
        }

        ajax.put(self.props.url,
            {
                requestData: requestData,
                success: function () {
                    if (callbackSuccess) {
                        callbackSuccess();
                    }
                }
            });
    }

    handleClearValue(event) {
        event.preventDefault();
        event.stopPropagation();

        const self = this;

        self.props.row[self.props.fieldName] = '';
        self.saveData('', self, function () {
            self.acceptChanges(self);
        });

        if (self.props.handleCompleteSave) {
            self.props.handleCompleteSave();
        }
    }

    acceptChanges(self) {
        self.setState({
            mode: Constants.MODE_VIEW,
            pendingChanges: {}
        }, function () {
            if (self.props.rowChanged) {
                self.props.rowChanged(self.props.row);
            }
        });
        this.hasChanges = false;
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.handleCompleteEdition(event);
        }
    }

    setInputValue(value, fieldName) {
        this.state.pendingChanges[fieldName] = value;
        this.hasChanges = true;
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.manageTrashButton && !this.state.manageTrashButton.equals(nextProps.manageTrashButton)) {
            this.setState({
                manageTrashButton: nextProps.manageTrashButton
            });
        }
    }

    render() {

        const self = this;
        const hasRequiredValidation = validation.hasSpecificValidation(self.state.validators, 'required');
        const hasUrlValidation = validation.hasSpecificValidation(self.state.validators, 'url');

        const wrapperClass = (this.props.wrapperClass || '') + ' data-placeholder-container';

        if (self.state.mode === Constants.MODE_VIEW) {

            let buttonTrash;
            let showTrashButton = false;

            if (this.state.manageTrashButton) {
                if (this.state.manageTrashButton.show) {
                    showTrashButton = true;
                }
            } else if (!hasRequiredValidation) {
                showTrashButton = true;
            }

            if (showTrashButton) {
                buttonTrash = <button type="button" className="btn btn-secondary" onClick={self.handleClearValue.bind(self)}><i className="fas fa-trash-alt" /></button>;
            }

            let showedValue;
            if (hasUrlValidation) {
                showedValue = <a href="#/">{this.props.row[this.props.fieldName]}</a>
            }
            else {
                showedValue = this.props.row[this.props.fieldName];
            }

            if (this.props.row[this.props.fieldName]) {
                return (<div className={wrapperClass}>
                    <span className="panel-edit" onClick={self.handleStartEdition.bind(self)}>
                        <div className="btn-group btn-group-edit-content">
                            <button type="button" className="btn btn-secondary" onClick={self.handleStartEdition.bind(self)}><i className="fas fa-pencil-alt" /></button>
                            {buttonTrash}
                        </div>
                        {showedValue}
                    </span>
                </div>);
            }
            else {
                return <div className={wrapperClass} onClick={self.handleStartEdition.bind(self)}>
                    <button className="btn btn-data-placeholder">
                        <i className="fas fa-plus-circle" />
                        Add {this.state.alias}
                    </button>
                </div>;
            }

        }
        else {

            return (<div className={wrapperClass} onKeyPress={this.handleKeyPress.bind(this)}>
                <InputText value={this.props.row[this.props.fieldName]}
                    fieldName={this.props.fieldName}
                    tableName={this.props.tableName}
                    className={this.props.className || 'form-control form-control-w-sm'}
                    wrapperClassName="add-data"
                    handleOnBlur={this.handleCompleteEdition.bind(this)}
                    validationAsTooltip
                    showClearButton={!hasRequiredValidation}
                    row={this.props.row}
                    placeholder={this.props.placeholder}
                    setInputValue={this.setInputValue.bind(this)} />
            </div>);
        }
    }

}


InlineTextEditor.propTypes = {
    tableName: PropTypes.string
}